<div class="page-wrap">
  <section class="glass-panel setup-shell">
    <div class="setup-header">
      <div>
        <p class="eyebrow">Setup Wizard</p>
        <h1 class="hero-title">Bring a business from signup to Cloud API onboarding.</h1>
      </div>
      <ion-progress-bar [value]="currentStep / 4"></ion-progress-bar>
    </div>

    <ion-segment [value]="currentStep.toString()">
      <ion-segment-button value="1">
        <ion-label>Business</ion-label>
      </ion-segment-button>
      <ion-segment-button value="2">
        <ion-label>Facebook</ion-label>
      </ion-segment-button>
      <ion-segment-button value="3">
        <ion-label>Phone</ion-label>
      </ion-segment-button>
      <ion-segment-button value="4">
        <ion-label>Coexistence</ion-label>
      </ion-segment-button>
    </ion-segment>

    <div [formGroup]="form">
      <div *ngIf="currentStep === 1" class="form-grid step-panel">
        <ion-item>
          <ion-label position="stacked">Business name</ion-label>
          <ion-input formControlName="businessName"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Business email</ion-label>
          <ion-input type="email" formControlName="businessEmail"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Business phone</ion-label>
          <ion-input formControlName="businessPhone"></ion-input>
        </ion-item>
      </div>

      <div *ngIf="currentStep === 2" class="form-grid step-panel">
        <div class="callout meta-config-card" *ngIf="metaConfig">
          <p class="eyebrow">Server-side Meta Config</p>
          <p class="subtle-copy">PingoraX is already linked to your Meta app on the backend.</p>
          <ion-list lines="none">
            <ion-item>
              <ion-label>Meta App ID</ion-label>
              <ion-note slot="end">{{ metaConfig.app_id }}</ion-note>
            </ion-item>
            <ion-item>
              <ion-label>Business Portfolio</ion-label>
              <ion-note slot="end">{{ metaConfig.business_portfolio_id }}</ion-note>
            </ion-item>
            <ion-item>
              <ion-label>Graph Version</ion-label>
              <ion-note slot="end">{{ metaConfig.graph_version }}</ion-note>
            </ion-item>
            <ion-item>
              <ion-label>App Secret</ion-label>
              <ion-note slot="end">{{ metaConfig.has_app_secret ? 'Stored on backend' : 'Missing' }}</ion-note>
            </ion-item>
          </ion-list>
        </div>

        <ion-text color="warning" *ngIf="configError">{{ configError }}</ion-text>

        <div class="callout">
          <p class="eyebrow">Recommended</p>
          <h2 class="section-title">Connect WhatsApp with Facebook</h2>
          <p class="subtle-copy">
            Launch Meta embedded signup to let the user log in, select the business, and auto-fetch
            WABA plus phone number IDs without pasting them manually.
          </p>
          <ion-button fill="outline" type="button" (click)="connectFacebook()" [disabled]="isConnectingFacebook">
            {{ isConnectingFacebook ? 'Opening Facebook...' : 'Connect WhatsApp with Facebook' }}
          </ion-button>
          <p class="subtle-copy" *ngIf="connectMessage">{{ connectMessage }}</p>
        </div>

        <div class="callout">
          <p class="eyebrow">Connection Result</p>
          <ion-item>
            <ion-label position="stacked">Facebook Business Manager ID</ion-label>
            <ion-input formControlName="facebookBusinessId" readonly="true"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="stacked">WABA ID</ion-label>
            <ion-input formControlName="wabaId" readonly="true"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="stacked">Phone Number ID</ion-label>
            <ion-input formControlName="phoneNumberId" readonly="true"></ion-input>
          </ion-item>
        </div>

        <div class="callout">
          <p class="eyebrow">Advanced Manual Fallback</p>
          <p class="subtle-copy">
            Use this only if embedded signup is not available yet and you already have a Meta access token.
          </p>
          <ion-item>
            <ion-label position="stacked">Meta access token</ion-label>
            <ion-input formControlName="metaAccessToken"></ion-input>
          </ion-item>
          <ion-button
            fill="clear"
            type="button"
            (click)="validateManualFacebookConnection()"
            [disabled]="isConnectingFacebook || !form.controls.metaAccessToken.value"
          >
            Validate Manual Token
          </ion-button>
        </div>
      </div>

      <div *ngIf="currentStep === 3" class="form-grid step-panel">
        <ion-item>
          <ion-label position="stacked">Phone number</ion-label>
          <ion-input formControlName="phoneNumber"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Phone number ID</ion-label>
          <ion-input formControlName="phoneNumberId"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Verification OTP</ion-label>
          <ion-input formControlName="verificationCode"></ion-input>
        </ion-item>
      </div>

      <div *ngIf="currentStep === 4" class="step-panel">
        <div class="glass-panel coexist-card">
          <div class="toggle-row">
            <div>
              <p class="eyebrow">WhatsApp Coexistence</p>
              <h2 class="section-title">Use the same number for the app and the API</h2>
            </div>
            <ion-toggle formControlName="coexistenceEnabled"></ion-toggle>
          </div>

          <p class="subtle-copy" *ngIf="form.controls.coexistenceEnabled.value">
            You can continue using WhatsApp app along with automation.
          </p>

          <ion-list lines="none">
            <ion-item>Keep existing WhatsApp Business App usage intact</ion-item>
            <ion-item>Send templates and bulk campaigns through API</ion-item>
            <ion-item>Store account state and logs without breaking manual messaging</ion-item>
          </ion-list>
        </div>
      </div>

      <ion-text color="success" *ngIf="successMessage">{{ successMessage }}</ion-text>

      <div class="wizard-actions">
        <ion-button fill="clear" type="button" (click)="previousStep()" [disabled]="currentStep === 1">
          Back
        </ion-button>
        <ion-button fill="solid" type="button" *ngIf="currentStep < 4" (click)="nextStep()">
          Next
        </ion-button>
        <ion-button fill="solid" color="primary" *ngIf="currentStep === 4" (click)="submit()" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Saving...' : 'Finish onboarding' }}
        </ion-button>
      </div>
    </div>
  </section>
</div>
